import { Component, Input } from '@angular/core';

import { ModalController, NavParams, PopoverController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { NavUrls } from '../../../enums/nav-urls';

import { AlertService, AlertDialogButtonClick } from '../../../services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ImplementService } from '../../../services/implement.service';

import {
  ImplementV2Dto,
  ImplementRestService,
  ExaBeaconV2Dto,
  PageDtoExaBeaconV2Dto,
  ExaBeaconRestService,
  EmployerDto,
} from '../../../api/exa';
import { ExaBeaconService } from 'src/app/services/exa-beacon.service';
import { BeaconTypeEnum } from 'src/app/enums/beacon-type-enum';
import { EmployerService } from 'src/app/services/employer.service';

@Component({
  selector: '',
  templateUrl: './implement-context-menu.component.html',
  styleUrls: ['../popover.component.scss'],
})
export class ImplementContextMenuComponent {
  @Input()
  implementDto: ImplementV2Dto;
  implementId: number;

  beaconList: PageDtoExaBeaconV2Dto[] = [];
  beaconsList: ExaBeaconV2Dto[] = [];
  temp_beaconsList: ExaBeaconV2Dto[] = [];

  hasGrantToWriteImplement: boolean = false;

  selectedBeacon: ExaBeaconV2Dto = null;
  disableAssign = false;

  currentEmployer: EmployerDto = null;

  constructor(
    private navParams: NavParams,
    private router: Router,
    private popoverController: PopoverController,
    private alertService: AlertService,
    private translate: TranslateService,
    private implementService: ImplementService,
    private implementRestService: ImplementRestService,
    private beaconRestService: ExaBeaconRestService,
    private beaconService: ExaBeaconService,
    private modalController: ModalController,
    private toastController: ToastController,
    private employerService: EmployerService
  ) {
    this.employerService.onSelectEmployer().subscribe((employer) => {
      this.currentEmployer = employer;
    });

    this.implementDto = this.navParams.data.implementDto;

    this.hasGrantToWriteImplement = this.navParams.data.hasGrantToWriteImplement;

    this.implementId = this.implementDto.id;

    this.beaconRestService.getBeaconsUsingPOST(this.currentEmployer.username).forEach((beacon) => {
      beacon.content.forEach((el) => {
        if (el.type === BeaconTypeEnum.B_IMPLEMENT) {
          this.beaconsList.push(el);
          this.temp_beaconsList.push(el);
        }
      });
    });
  }

  onClickEdit() {
    let editImplementUrl = NavUrls.IMPLEMENTS + '/' + NavUrls.ADDIMPLEMENT + '/' + this.implementDto.id;
    this.router.navigateByUrl(editImplementUrl);
    this.DismissClick();
  }

  onClickDelete() {
    this.onClickDeleteImplement(this.implementDto.id);
  }

  onClickDeleteImplement(implementId: number) {
    this.alertService
      .presentConfirmAlert(this.translate.instant('WARNING'), this.translate.instant('IMPLEMENT.DELETE.QUESTION'))
      .then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          console.log(' User hat Löschung bestätigt');

          this.implementService.deleteImplement(implementId).finally(() => {
            // egal was passiert das popover schliesst sich
            this.DismissClick();
          });
        }
      });
  }

  onSearch(e) {
    const query = e.detail.value.toLowerCase();
    this.beaconsList = this.temp_beaconsList.filter((d) => d.serial?.toLowerCase().indexOf(query) > -1);
  }

  onClickActivate() {
    this.implementDto.active = true;
    this.implementRestService.updateImplementUsingPUT(this.implementDto.id, this.implementDto).subscribe(
      (ret) => {
        console.log(' return: ', ret);
        this.DismissClick();
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
  }

  onClickDeactivate() {
    this.implementDto.active = false;
    this.implementRestService.updateImplementUsingPUT(this.implementDto.id, this.implementDto).subscribe(
      (ret) => {
        console.log(' return: ', ret);
        this.DismissClick();
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
  }

  async DismissClick() {
    await this.popoverController.dismiss('dismissed');
  }

  selectBeacon(beacon) {
    this.selectedBeacon = beacon;
    this.beaconRestService.assignToImplementUsingPOST(this.implementId, beacon).subscribe((data) => {
      if (data) {
        this.onSelectedbeacon();
      }
    });
    this.popoverController.dismiss();
    this.modalController.dismiss();
    this.beaconsList = this.temp_beaconsList;
    this.toastController
      .create({
        message: this.translate.instant('Beacon verbunden mit Anbaugerät ' + this.implementDto.name),
        duration: 3000,
      })
      .then((toast) => {
        this.beaconsList = [];
        toast.present();
      });
  }

  onSelectedbeacon() {
    if (this.selectedBeacon) {
      this.implementService.reloadImplements();
      this.beaconService.reloadBeacons();
    }
  }
}
